
const initialState = {
    messages: false,
    file_types : false
}

export const messagesReducer = (state = initialState, action = {}) => {
   switch (action.type) {
         //case 'persist/REHYDRATE':
         //   return action.payload ? action.payload.messagesReducer ? action.payload.messagesReducer : state : state;
        case 'MESSAGES_FETCHED':
        	return {
                ...state,
                messages: action.payload
            }
        case 'FILETYPES_FETCHED':
            return {
                ...state,
                file_types: action.payload
            }
        case 'SET_MESSAGE_READ':
            let messages = state.messages;

            let singleMessageIndex =  messages.data.data.findIndex( message => message.message_id === action.payload);

            messages.data.data[singleMessageIndex]['has_been_read'] = "1";


            return {
                ...state,
                messages: messages
            }
        case 'SET_MESSAGE_READ_CLIENT_SIDE':
            let allMessages = state.messages;

            let singleIndex =  allMessages.data.data.findIndex( message => message.message_id === action.payload);

            allMessages.data.data[singleIndex]['has_been_read_clientside'] = "1";


            return {
                ...state,
                messages: allMessages
            }
        case 'DESTROY':
        case 'DESTROY_ADDRESSES':
            return initialState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/messagesReducer.js